const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://localhost:5002/",
    media_url: "https://localhost:5002/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "hue_phongquang",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
    datastore: 'hue_phongquang',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
  },
  production: {
    api: "https://dothiphongquang-api.cgis.asia//",
    media_url: "https://dothiphongquang-api.cgis.asia//",
    domainAdminSide: "https://dothiphongquang-admin.cgis.asia",
    domainUserSide: "https://dothiphongquang.cgis.asia",
    domainName: "cgis.asia",
    workSpace: "hue_phongquang",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
    datastore: 'hue_phongquang',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geo.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];